import { createFileRoute } from "@tanstack/react-router";

import { loadNamespaces } from "../../app/i18n";
import { MagicLinkLanding } from "../../shared/auth/MagicLinkLanding";

/** Magic-link landing (FE-05 FR-FE05-18…22). Public: the token lives in the fragment. */
export const Route = createFileRoute("/auth/link")({
  beforeLoad: () => loadNamespaces("auth"),
  component: MagicLinkLanding,
});
